
import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AboutUs = () => {
  const teamMembers = [
    {
      name: "Karan Kumar",
      role: "Founder & CEO",
      image: "Karan.jpg",
    },
    {
      name: "Poonam",
      role: "Head Baker",
      image: "Poonam.jpg",
    },
    {
      name: "Naresh Kumar",
      role: "Operations Head",
      image: "Naresh.jpg",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="about-wrapper">
      <motion.h1
        className="about-title"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Welcome to KP Bakers
      </motion.h1>

      <motion.p
        className="about-intro"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        Home of handmade love and warm pastries 🍰
      </motion.p>

      <section className="about-sections">
        {[
          {
            title: "Our Mission",
            content:
              "At KP Bakers, we are passionate about baking smiles. Our mission is to spread joy through delicious, high-quality baked goods made with love and care.",
          },
          {
            title: "Our Vision",
            content:
              "To become a leading artisanal bakery known for creativity, consistency, and customer delight. We dream big and bake bigger!",
          },
          {
            title: "Our History",
            content:
              "Founded in 2023 in a cozy kitchen, KP Bakers has grown from a family passion into a community favorite—one cupcake at a time.",
          },
        ].map((section, idx) => (
          <motion.div
            className="info-card"
            key={idx}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
          >
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </motion.div>
        ))}
      </section>

      <motion.section
        className="team-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <h2 className="team-heading">Meet Our Sweet Team</h2>
        <div className="carousel-container">
          <Slider {...settings}>
            {teamMembers.map((member, index) => (
              <motion.div
                className="team-card"
                key={index}
                whileHover={{ scale: 1.04 }}
                transition={{ type: "spring", stiffness: 260 }}
              >
                <div className="image-box">
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </motion.div>
            ))}
          </Slider>
        </div>
      </motion.section>

      {/* Internal Styling */}
      <style jsx>{`
        .about-wrapper {
          background: linear-gradient(to bottom right, #fffaf0, #ffdde1);
          padding: 60px 20px;
          font-family: "Segoe UI", sans-serif;
          color: #3a3a3a;
        }

        .about-title {
          font-size: 3rem;
          font-weight: bold;
          color: #e74c3c;
          text-align: center;
          margin-bottom: 10px;
        }

        .about-intro {
          text-align: center;
          font-size: 1.2rem;
          color: #555;
          margin-bottom: 50px;
        }

        .about-sections {
          display: flex;
          flex-direction: column;
          gap: 30px;
          max-width: 900px;
          margin: auto;
        }

        .info-card {
          background: rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(8px);
          padding: 30px;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          text-align: center;
        }

        .info-card h2 {
          font-size: 1.8rem;
          color: #c0392b;
          margin-bottom: 10px;
        }

        .info-card p {
          font-size: 1rem;
          line-height: 1.6;
          color: #333;
        }

        .team-section {
          margin-top: 60px;
        }

        .team-heading {
          text-align: center;
          font-size: 2.2rem;
          color: #8e44ad;
          margin-bottom: 30px;
        }

        .carousel-container {
          max-width: 500px;
          margin: 0 auto;
        }

        .team-card {
          background: white;
          border-radius: 16px;
          padding: 25px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          text-align: center;
        }

        .image-box {
          width: 180px;
          height: 180px;
          margin: 0 auto 20px;
          border-radius: 50%;
          overflow: hidden;
          box-shadow: 0 0 0 6px #fadadd;
        }

        .image-box img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .team-card h3 {
          font-size: 1.5rem;
          color: #e67e22;
          margin: 10px 0 5px;
        }

        .team-card p {
          font-size: 1rem;
          color: #7f8c8d;
        }

        @media (max-width: 768px) {
          .about-title {
            font-size: 2.2rem;
          }

          .info-card h2 {
            font-size: 1.4rem;
          }

          .info-card p,
          .team-card p {
            font-size: 0.95rem;
          }

          .image-box {
            width: 140px;
            height: 140px;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;
